// import {isValidPhoneNumber} from 'libphonenumber-js';

let isValidPhoneNumber = null;
import(/* webpackPreload: true, webpackChunkName: "ui-components" */'libphonenumber-js').then((libphonenumber) => {
    isValidPhoneNumber = libphonenumber.isValidPhoneNumber;
});

const PhoneNumber = (val) => {
    // const regex = /^[+0-9\s]{6,18}$/i;
    // const valid = !val || regex.test(val);

    const fakeNumberRegex = /^07700\s?900[0-9]{3}$/i;

    if (!isValidPhoneNumber) {
        return [
            true,
            null,
        ]
    }

    const valid = !val || isValidPhoneNumber(val, 'GB') || fakeNumberRegex.test(val);

    return [
        valid,
        valid ? null : 'Please enter a valid phone number',
    ]
}

export default PhoneNumber;